import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor, OnyxOptional } from '@onyx/angular';
import {
  OnyxDatePipe,
  OnyxInformationHeadingComponent,
  OnyxTimePipe,
} from '@onyx/angular';
import type { SwapPoint } from '../../../../../../fleet/common/interfaces/technical-point';
import { DriverReportModalImageComponent } from '../../../../../../orders/common/components/driver-report-modal/driver-report-modal-image/driver-report-modal-image.component';
import { OrderHelper } from '../../../../../../orders/common/helpers/order.helper';
import type {
  CompletedReport,
  InProgressReport,
} from '../../../../../../orders/common/interfaces/order-point-driver-reports';

@Component({
  selector: 'app-swap-modal-driver-report-item',
  imports: [
    OnyxDatePipe,
    OnyxTimePipe,
    OnyxInformationHeadingComponent,
    DriverReportModalImageComponent,
    TranslatePipe,
    NgTemplateOutlet,
  ],
  templateUrl: './swap-modal-driver-report-item.component.html',
  styleUrl: './swap-modal-driver-report-item.component.scss',
})
export class SwapModalDriverReportItemComponent {
  public readonly swapPoint = input.required<SwapPoint>();
  public readonly identifierColor = input.required<OnyxColor | null>();

  protected inProgressFiles = computed(() =>
    this.getFilteredFiles(this.swapPoint().driverReports?.['in-progress']),
  );
  protected completedFiles = computed(() =>
    this.getFilteredFiles(this.swapPoint().driverReports?.completed),
  );

  private getFilteredFiles(
    report: OnyxOptional<InProgressReport | CompletedReport>,
  ) {
    return OrderHelper.getDriverReportRawFilesData(report ?? null).filter(
      (item) => !!item.files.length,
    );
  }
}
